<ng-template #nodeTpl let-node let-siblings="siblings" let-depth="depth">
  <div class="config-item">
    <span class="drag-handle" cdkDragHandle>
      <span nz-icon nzType="holder" nzTheme="outline"></span>
    </span>

    <span
      class="status-dot"
      [class]="statusFor(node)"
      (click)="selectCurrent(node)"
      nz-tooltip
      nzTooltipTitle="Mark as current node"
    ></span>

    <input
      nz-input
      class="name-input"
      placeholder="Name"
      [(ngModel)]="node.data.name"
      (ngModelChange)="emitNodes()"
    />

    <nz-select
      class="variable-select"
      nzPlaceHolder="As-is variable"
      nzShowSearch
      [nzFilterOption]="filterVariableOption"
      [(ngModel)]="node.data.variable_as_is"
      (ngModelChange)="emitNodes()"
    >
      @for (col of columnDefinitions; track col.field) {
        <nz-option nzCustomContent [nzValue]="col.field" [nzLabel]="col.headerName ?? col.field">
          <div class="option-row">
            <div class="option-label">{{ col.headerName ?? col.field }}</div>
            <div class="option-field">{{ col.field }}</div>
          </div>
        </nz-option>
      }
    </nz-select>

    <nz-select
      class="variable-select"
      nzPlaceHolder="To-be variable"
      nzShowSearch
      [nzFilterOption]="filterVariableOption"
      nzAllowClear
      [(ngModel)]="node.data.variable_to_be"
      (ngModelChange)="emitNodes()"
    >
      @for (col of columnDefinitions; track col.field) {
        <nz-option nzCustomContent [nzValue]="col.field" [nzLabel]="col.headerName ?? col.field">
          <div class="option-row">
            <div class="option-label">{{ col.headerName ?? col.field }}</div>
            <div class="option-field">{{ col.field }}</div>
          </div>
        </nz-option>
      }
    </nz-select>

    <nz-select
      class="variable-select"
      nzPlaceHolder="To-be offset variable"
      nzShowSearch
      [nzFilterOption]="filterVariableOption"
      nzAllowClear
      [(ngModel)]="node.data.variable_offset_to_be"
      (ngModelChange)="emitNodes()"
    >
      @for (col of columnDefinitions; track col.field) {
        <nz-option nzCustomContent [nzValue]="col.field" [nzLabel]="col.headerName ?? col.field">
          <div class="option-row">
            <div class="option-label">{{ col.headerName ?? col.field }}</div>
            <div class="option-field">{{ col.field }}</div>
          </div>
        </nz-option>
      }
    </nz-select>

    <button nz-button nzType="text" nzSize="small" (click)="addChildNode(node)">
      <span nz-icon nzType="plus" nzTheme="outline"></span> Child
    </button>
    <button nz-button nzType="text" nzSize="small" nzDanger (click)="removeNode(siblings, node)">
      <span nz-icon nzType="delete" nzTheme="outline"></span>
    </button>
  </div>

  @if (node.children.length) {
    <div class="children" cdkDropList [cdkDropListData]="node.children" (cdkDropListDropped)="drop($event, node.children)">
      @for (child of node.children; track child.id) {
        <div class="node-wrapper" cdkDrag [style.--depth]="depth + 1">
          <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: child, siblings: node.children, depth: depth + 1 }"></ng-container>
        </div>
      }
    </div>
  }
</ng-template>

<div class="config-root">
  <div class="root-list" cdkDropList [cdkDropListData]="nodes" (cdkDropListDropped)="drop($event, nodes)">
    @for (node of nodes; track node.id) {
      <div class="node-wrapper" cdkDrag [style.--depth]="0">
        <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: node, siblings: nodes, depth: 0 }"></ng-container>
      </div>
    }
  </div>

  <button nz-button nzType="dashed" class="add-root" (click)="addRootNode()">
    <span nz-icon nzType="plus" nzTheme="outline"></span> Add node
  </button>
</div>
